import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import SayHelloBtn from "../buttons/SayHelloBtn";

const SayHello = ({ theme }) => {
  return (
    <div className=" py-20">
      <div className="flex flex-col items-center gap-8">
        <h3
          className={`${
            theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
          } text-[30px] text-center leading-8 md:leading-none font-bold`}
        >
          Let's create awesome products!
        </h3>
        <p
          className={`${
            theme === "dark"
              ? "text-darkTextColor font-light"
              : "text-lightTextColor font-normal"
          } text-2xl -mt-4 text-center md:text-center`}
        >
          I am always open to discussing your project, improving your online
          presence, or helping with
          <br />
          Your website's design and converting challenges.
        </p>
        <Link to="/contact">
          <SayHelloBtn theme={theme} />
        </Link>
      </div>
      <div className="flex flex-col mdl:flex-row justify-center items-center gap-6 mdl:gap-16 pt-16">
        <a
          href="https://github.com/noorjsdivs"
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              theme === "dark"
                ? "text-[#BEDBFE] border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl relative flex justify-between items-center group gap-2 hover:underline decoration-1 underline-offset-4 border-b-[1px] mdl:border-b-0 py-2 mdl:py-0`}
          >
            Github
            <span>
              <FiArrowUpRight className="absolute top-3 mdl:top-1 group-hover:translate-x-2 group-hover:-translate-y-2 transition-translate duration-300" />
            </span>
          </p>
        </a>
        <a
          href="https://www.youtube.com/@reactjsBD"
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              theme === "dark"
                ? "text-[#BEDBFE] border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl relative flex justify-between items-center group gap-2 hover:underline decoration-1 underline-offset-4 border-b-[1px] mdl:border-b-0 py-2 mdl:py-0`}
          >
            Youtube
            <span>
              <FiArrowUpRight className="absolute top-3 mdl:top-1 group-hover:translate-x-2 group-hover:-translate-y-2 transition-translate duration-300" />
            </span>
          </p>
        </a>
        <a
          href="https://www.linkedin.com/in/noor-mohammad-ab2245193/"
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              theme === "dark"
                ? "text-[#BEDBFE] border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl relative flex justify-between items-center group gap-2 hover:underline decoration-1 underline-offset-4 border-b-[1px] mdl:border-b-0 py-2 mdl:py-0`}
          >
            Linkedin
            <span>
              <FiArrowUpRight className="absolute top-3 mdl:top-1 group-hover:translate-x-2 group-hover:-translate-y-2 transition-translate duration-300" />
            </span>
          </p>
        </a>
        <a
          href="https://www.facebook.com/Noorlalu143/"
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              theme === "dark"
                ? "text-[#BEDBFE] border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl relative flex justify-between items-center group gap-2 hover:underline decoration-1 underline-offset-4 border-b-[1px] mdl:border-b-0 py-2 mdl:py-0`}
          >
            Facebook
            <span>
              <FiArrowUpRight className="absolute top-3 mdl:top-1 group-hover:translate-x-2 group-hover:-translate-y-2 transition-translate duration-300" />
            </span>
          </p>
        </a>
        <a
          href="https://vercel.com/noorjsdivs"
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              theme === "dark"
                ? "text-[#BEDBFE] border-darkLineColor"
                : "text-lightTextColor border-lightLineColor"
            } text-xl relative flex justify-between items-center group gap-2 hover:underline decoration-1 underline-offset-4 border-b-[1px] mdl:border-b-0 py-2 mdl:py-0`}
          >
            Nextjs
            <span>
              <FiArrowUpRight className="absolute top-3 md:top-1 group-hover:translate-x-2 group-hover:-translate-y-2 transition-translate duration-300" />
            </span>
          </p>
        </a>
      </div>
    </div>
  );
};

export default SayHello;
